import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import { getCookie } from "../../utils/cookieHandler";
import useUsersLogic from "./useUsersLogic";

const columns = [
  {
    field: "concat",
    label: "Name",
    allowSorting: true,
    concatBy: " ",
    concat: [{ field: "first_name" }, { field: "last_name" }],
  },
  { field: "email", label: "Email", allowSorting: true },
  {
    field: "role",
    label: "Role",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
];

const UsersPage = () => {
  const { addRoles, apiRoute, deleteRoles, editRoles, initFields, tabsData } =
    useUsersLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      const promises = [fetchDataAndMapToField(config, "roles", "role", temp)];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Users" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="directus_users"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default UsersPage;
